import React from 'react';
import { useDetails } from './useDetails';
import { Assignment } from './assignment';
import { ContactPersons } from './contactPersons';
import { AssignmentEditModal } from './assignment/edit';
import { convertEnumsToReadableStrings } from 'utils/helpers';
import { Col, Row, Skeleton, Typography } from 'components';
import { DealStatusBadge } from 'components/common/StatusBadge/DealStatusBadge';
import styles from './styles.module.scss';
import { ADMIN_ROUTES } from 'constants/routes';
import { Link } from 'react-router-dom';

export const Details = React.memo(() => {
  const {
    onUpdateAssignmentClick,
    dealDetails,
    openAssignmentEditModal,
    onCloseAssignmentEditModal,
    assignmentData,
    isLoading,
    isFinalStatus,
  } = useDetails();

  if (isLoading) {
    return (
      <Row gutter={[32, 32]}>
        <Col span={24}>
          <Skeleton active />
        </Col>
        <Col span={24}>
          <Skeleton active />
        </Col>
        <Col span={24}>
          <Skeleton active />
        </Col>
      </Row>
    );
  }

  return (
    <>
      <Row gutter={[0, 16]}>
        <Col span={24} className={styles.main_info}>
          <Row justify={'space-between'} wrap={false}>
            <Col span={20}>
              <Row gutter={[0, 4]}>
                <Col span={24} style={{ marginTop: 5 }} className={styles.legal_name}>
                  <Typography.Text ellipsis={{ tooltip: true }} className={styles.name}>
                    ID: {dealDetails.uuid}
                  </Typography.Text>
                </Col>
                <Col span={24}>{dealDetails?.status ? <DealStatusBadge type={dealDetails?.status} /> : ''}</Col>
              </Row>
            </Col>
          </Row>
          <Row className={'margin-t-4'}>
            {dealDetails?.rejectionReason ? (
              <Col span={24} style={{ marginTop: 8 }}>
                <Typography.Text ellipsis={{ tooltip: true }} style={{ fontSize: 16 }}>
                  {convertEnumsToReadableStrings(dealDetails?.rejectionReason)}
                </Typography.Text>
              </Col>
            ) : (
              ''
            )}

            <Col span={24} style={{ marginBottom: 8 }}>
              {dealDetails?.rejectionAdditionalInformation ? (
                <Typography.Text ellipsis={{ tooltip: true }}>
                  {dealDetails?.rejectionAdditionalInformation}
                </Typography.Text>
              ) : (
                ''
              )}
            </Col>
            <Col span={24}>
              <Row className={'gap-8'} wrap={false} align={'middle'}>
                <Typography.Text className={'font-size-12'} style={{ color: '#99A0AE' }}>
                  {dealDetails.formattedCreatedDate}
                </Typography.Text>
                <Typography.Text className={'font-size-12'} style={{ color: '#99A0AE' }}>
                  {dealDetails.formattedLastModifiedDate}
                </Typography.Text>
              </Row>
            </Col>
            <Col span={12}>
              <Row align={'middle'} style={{ marginTop: 12 }}>
                <Typography.Text ellipsis={{ tooltip: true }} type={'secondary'}>
                  CREATED BY <br />
                  {dealDetails?.createdBy?.firstName || ''} {dealDetails?.createdBy?.lastName || ''}
                </Typography.Text>
              </Row>
            </Col>
            <Col span={12}>
              <Row align={'middle'} style={{ marginTop: 12 }}>
                <Typography.Text ellipsis={{ tooltip: true }} type={'secondary'}>
                  LAST UPDATED BY <br />
                  {dealDetails.lastModifiedBy?.firstName || ''} {dealDetails.lastModifiedBy?.lastName || ''}
                </Typography.Text>
              </Row>
            </Col>
            {dealDetails.leadId ? (
              <Col className={'margin-t-12'} span={24}>
                <Link to={`${ADMIN_ROUTES.leads.view}/${dealDetails.leadId}/general`} target={'_blank'}>
                  <Typography.Text className={styles.link_text} underline>
                    Original Lead
                  </Typography.Text>
                </Link>
              </Col>
            ) : (
              ''
            )}
          </Row>
        </Col>
        <ContactPersons />
        <Assignment
          isFinalStatus={isFinalStatus}
          assignmentData={assignmentData}
          onUpdateAssignmentClick={onUpdateAssignmentClick}
        />
      </Row>
      <AssignmentEditModal open={openAssignmentEditModal} onCancel={() => onCloseAssignmentEditModal()} />
    </>
  );
});
